import React, { lazy, Suspense } from "react";
import AddToHome from "../../components/addToHome";
import ScrollBanner from "../../components/scrollBanner";
import { Link } from "react-router-dom";

// import Footer from "../../components/footer"
import ProductCategory from "../../components/home/category/index.jsx"
import PcLandingPage from "../../components/landing-page/index.jsx"
import Layout from "../../components/layout"
import NavBar from "../../components/navBar/navBar"
// import PcNav from "../../components/nav-bar/pcNav"
// import ScrollBanner from "../../components/scroll-banner"
import PcScrollBanner from "../../components/scrollBanner/pcBanner"
import Search from "../../components/search"
import ShopByCompany from "../../components/shop-by-company"
import StoreBakery from "../../components/store/bakery"
import StoreDairy from "../../components/store/dairy"
import StoreDryFruits from "../../components/store/dry-fruits"
import StoreFruits from "../../components/store/fruits"
import StoreVegetable from "../../components/store/vegetables"
import Testimonial from "../../components/testimonial"
import TopCategorie from "../../components/top-category"
import PcCategory from "../../components/top-category/pcCategory"

const Nav = lazy(() => import("../../components/navBar"));
const PcNav = lazy(() => import("../../components/navBar/pcNav"));
const Category = lazy(() => import("../../components/category"));
const Banner = lazy(() => import("../../components/banner"));
const Homeveg = lazy(() => import("./vegetable"));
const Homekirana = lazy(() => import("./kirana"));
const Homefruits = lazy(() => import("./fruits"));
const Homebakery = lazy(() => import("./bakery"));
const Homedairy = lazy(() => import("./dairy"));
const Footer = lazy(() => import("../../components/footer"));
const Companycat = lazy(() => import("../../components/subCat/company"));
const Kiranacat = lazy(() => import("../categories/sub-cat/kirana"));
const Homedelivery = lazy(() => import("./poster/delivery"));
const Bakerycat = lazy(() => import("../categories/sub-cat/bakery"));
const Patanjalicat = lazy(() => import("../categories/sub-cat/patanjali"));
const WhatsAppAdd = lazy(() => import("../../components/whatsapp"));
const CallUs = lazy(() => import("../../components/contactCard"));
const NanoCat = lazy(() => import("./kirana/nanoCat"));

function PcHome() {
  return (
    <div className="pc-home-container">
      <PcNav />
      <div className="pc-home-component">
        <PcLandingPage />
        <PcScrollBanner
          firstImage={
            "https://www.jiomart.com/images/cms/aw_rbslider/slides/1619712023_mumbai.jpg"
          }
          firstLink={"/category/vegetables"}
          secondImage={
            "https://www.jiomart.com/images/cms/aw_rbslider/slides/1608042045_7_web.jpg"
          }
          secondLink={"/category/kirana"}
          thirdImage={
            "https://www.jiomart.com/images/cms/aw_rbslider/slides/1618323464_mangoweb.jpg"
          }
          thirdLink={"/category/fruits"}
        />
        <PcCategory />
        <StoreVegetable />
        <StoreFruits />
        <StoreDairy />
        <StoreBakery />
        <StoreDryFruits />
        <PcScrollBanner
          firstImage={
            "https://www.jiomart.com/images/cms/aw_rbslider/slides/1619197343_web.jpg"
          }
          firstLink={"/category/vegetables"}
          secondImage={
            "https://www.jiomart.com/images/cms/aw_rbslider/slides/1619545857_web.jpg"
          }
          secondLink={"/category/kirana"}
          thirdImage={
            "https://www.jiomart.com/images/cms/aw_rbslider/slides/1619024818_web.jpg"
          }
          thirdLink={"/category/fruits"}
        />
        <div className="double-banner mw-14">
          <Link to="/category/fruits">
            <img
              src="https://images-eu.ssl-images-amazon.com/images/G/31/img17/Pantry/Oct2020/Coop/Festive_store_750x375.jpg"
              alt="fruits banner"
              className="banners"
            />
          </Link>
          <Link to="/category/fruits">
            <img
              src="https://images-eu.ssl-images-amazon.com/images/G/31/img17/AmazonPantry/DaburSF/Range-Banner_51_750x375.jpg"
              alt="fruits banner"
              className="banners"
            />
          </Link>
        </div>
        <div className="double-banner mw-14">
          <Link to="/category/fruits">
            <img
              src="https://images-eu.ssl-images-amazon.com/images/G/31/img17/Pantry/Sept2020/Coop/Henko750x375px.jpg"
              alt="fruits banner"
              className="banners"
            />
          </Link>
          <Link to="/category/fruits">
            <img
              src="https://images-eu.ssl-images-amazon.com/images/G/31/img17/AmazonPantry/February/NiveaSVDBanners/750x375.jpg"
              alt="fruits banner"
              className="banners"
            />
          </Link>
        </div>
        <div className="mw-14">
          <ShopByCompany />
          <Testimonial />
        </div>
      </div>

      <Footer />
    </div>
  );
}

function PhoneHome() {
  return (
    <Layout>
      <div className="home-container ">
        <NavBar />
        <Search />
        <ProductCategory />
        <ScrollBanner />
        <Link to="/categroy/kirana">
          <img
            src="https://www.jiomart.com/images/cms/aw_rbslider/slides/1611339553_free_header.jpg"
            alt="add-banner"
            className="banners"
          />
        </Link>
        <TopCategorie />
        <Link to="/category/kirana">
          <img
            src="https://www.jiomart.com/images/cms/aw_rbslider/slides/1614276050_webmobi.jpg"
            alt="kirana-banner"
            className="banners"
          />
        </Link>
        <StoreVegetable />
        <StoreFruits />
        <StoreDairy />
        <StoreBakery />
        <StoreDryFruits />
        <Link to="/category/kirana">
          <img
            src="https://www.jiomart.com/images/cms/aw_rbslider/slides/1614276050_webmobi.jpg"
            alt="kirana-banner"
            className="banners"
          />
        </Link>
        <Link to="/category/kirana">
          <img
            src="https://www.jiomart.com/images/cms/aw_rbslider/slides/1611320794_chips-wefers-600X350.jpg"
            alt="kirana-banner"
            className="banners"
          />
        </Link>
        <Link to="/category/kirana">
          <img
            src="https://www.jiomart.com/images/cms/aw_rbslider/slides/1611320467_Instant-Foods-600-x-350.jpg"
            alt="kirana-banner"
            className="banners"
          />
        </Link>
        <Link to="/category/kirana">
          <img
            src="https://www.jiomart.com/images/cms/aw_rbslider/slides/1611077647_knorr_webmini.jpg"
            alt="kirana-banner"
            className="banners"
          />
        </Link>
        <Link to="/category/kirana">
          <img
            src="https://www.jiomart.com/images/cms/aw_rbslider/slides/1611337391_oreo_mobile.jpg"
            alt="kirana-banner"
            className="banners"
          />
        </Link>
        <Link to="/categroy/kirana">
          <img
            src="https://www.jiomart.com/images/cms/aw_rbslider/slides/1614451530_mobiwm.jpg"
            alt="add-banner"
            className="banners"
          />
        </Link>

        <ShopByCompany />
        <Testimonial />

        <Footer />
      </div>
    </Layout>
  );
}

export default function Home() {
  return (
    <Suspense
      fallback={
        <h3>
          <center>Loading..</center>
        </h3>
      }
    >
      <div className="index-page">
        <section className="pc-home-section">
          <PcHome />
        </section>
        <section className="phone-home-section">
          <PhoneHome />
        </section>
      </div>
    </Suspense>
  );
}
